module.exports = __webpack_public_path__ + "static/media/recruitment-process.8ce485d6.jpg";